import React, { useEffect, useState } from 'react';
import CustomButton from '../../../../components/customButton';
import { useDispatch, useSelector } from 'react-redux';
import { getIntegrations } from '../../../../redux/integration/actions';
import CustomInput from '../../../../components/customInput';
import API from '../../../../services/api';
import utils from '../../../../utils';
import { setAlert } from '../../../../redux/dashboard/actions';
import { getSelectedProject } from '../../../../redux/projects/actions';

const UpdateForm = ({ mapping, onUpdate }) => {
  const [displayName, setDisplayName] = useState(mapping.displayName ? mapping.displayName : '');
  const [values, setValues] = useState(mapping.metadata);
  const [selectedIntegration, setSelectedIntegration] = useState(null);
  const [buttonIsLoading, setButtonIsLoading] = useState(false);

  const integrations = useSelector(getIntegrations);
  const project = useSelector(getSelectedProject);
  const dispatch = useDispatch();

  useEffect(() => {
    if (integrations && mapping) {
      setSelectedIntegration(integrations.find(int => int.vendor === mapping.vendor));
    }
  }, []);

  const updateForm = (field, val) => {
    setValues({ ...values, [field]: val });
  };

  const formatVendorName = vendor => {
    return vendor[0].toUpperCase() + vendor.slice(1).toLowerCase();
  };

  const updateMapping = () => {
    setButtonIsLoading(true);
    API.updateMapping(project.id, mapping.id, { ...mapping, metadata: values, displayName }, [
      'metadata',
      'displayName'
    ])
      .then(() => {
        dispatch(setAlert(utils.generateAlert('Mapping updated successfuly!', 'success')));
        onUpdate();
      })
      .catch(err => {
        console.error(err);
        dispatch(setAlert(utils.generateAlert('Could not update this mapping. Try again later.', 'error')));
      })
      .finally(() => setButtonIsLoading(false));
  };

  const deleteMapping = () => {
    setButtonIsLoading(true);
    API.deleteMapping(project.id, mapping.id)
      .then(() => {
        dispatch(setAlert(utils.generateAlert('Mapping deleted successfuly!', 'success')));
        onUpdate();
      })
      .catch(err => {
        dispatch(setAlert(utils.generateAlert('Could not delete this mapping. Try again later.', 'error')));
        console.error(err);
      })
      .finally(() => setButtonIsLoading(false));
  };

  return (
    <div>
      <div className="form-row">
        <div className="col" key="integration-vendor">
          <div className="form-group">
            <label>Integration</label>
            <CustomInput
              id={`integration-vendor-${mapping?.id}`}
              type="text"
              value={
                selectedIntegration
                  ? formatVendorName(selectedIntegration.vendor)
                  : mapping?.vendor
                    ? formatVendorName(mapping.vendor)
                    : ''
              }
              isEditable={false}
              onChange={() => {}}
            />
          </div>
        </div>
        <div className="col" key="asset-name">
          <div className="form-group">
            <label>Asset Name</label>
            <CustomInput
              id={`asset-id-${mapping?.id}`}
              type="text"
              value={displayName}
              isEditable={true}
              onChange={e => setDisplayName(e.target.value)}
            />
          </div>
        </div>
      </div>
      <div className="form-row">
        {selectedIntegration &&
          selectedIntegration.mappingMetadataFields.map(field => {
            return (
              <div className="col" key={field}>
                <div className="form-group">
                  <label>{field}</label>
                  <CustomInput
                    id={`${mapping.id}-${field}`}
                    type="text"
                    value={values[field]}
                    isEditable
                    onChange={e => {
                      updateForm(field, e.target.value);
                    }}
                    autoFocus
                  />
                </div>
              </div>
            );
          })}
      </div>
      <div className="form-row justify-content-end">
        <CustomButton
          classes="btn-secondary btn-danger"
          title="Delete"
          handleClick={deleteMapping}
          loading={buttonIsLoading}
        />
        <CustomButton classes="btn-primary ml-2" title="Update" handleClick={updateMapping} loading={buttonIsLoading} />
      </div>
    </div>
  );
};

export default UpdateForm;
